import {Profile, TFile} from "@brg/api";
import {bProfile} from "@brg/auth";

export const uploadValidator = async (files: TFile[], toasts: any, isWideImageType: boolean, profile?: Profile<'Local'>, additionalValidate?: boolean) => {

    if (files?.length === 0 || !profile) return true;

    const isModer = bProfile.isModer(profile)
    const failedChecks: any = {}
    const loadFile = () =>
        new Promise((resolve, reject) => {
            const fr = new FileReader()
            fr.onload = function () {
                // file is loaded
                const img = new Image()

                img.onload = function () {
                    const { width, height } = img
                    resolve({
                        width,
                        height
                    })
                }

                // @ts-ignore
                img.src = fr.result // is the data URL because called with readAsDataURL
            }
            // @ts-ignore
            fr.readAsDataURL(files[0])
        })

    // @ts-ignore
    const { height, width } = await loadFile()

    if (
        (height >= width && (height > 5262 || width > 3720)) ||
        (width > height && (height > 3720 || width > 5262))
    ) {
        toasts.error('Максимальные размеры изображения - 3720х5262 и 5262x3720')
        failedChecks.dimensions = true
    }


    const ratio = width / height;


    if (isWideImageType) {
        // const isSmallWideImage = ratio > 1.47 && ratio < 1.49
        // const isLargeWideImage = ratio > 1.79 && ratio < 1.81
        // if (!isSmallWideImage && !isLargeWideImage) {
        //   toasts.error(
        //     'Изображение неправильное (отношение ширины к высоте должно быть или 1.48, или 1.8)'
        //   )
        //   failedChecks.ratio = true
        // }
    } else {
        if (ratio < 0.6) {
            toasts.error(
                'Изображение слишком длинное (отношение ширины к высоте должно быть 0.6 и более)'
            )
            failedChecks.ratio = true
        }
        if (additionalValidate) {
            if (ratio < 0.6 || ratio > 0.8) {
                toasts.error("Изображение должно быть вертикальным (отношение ширины к высоте от 0.6 до 0.8)");
                failedChecks.ratio = true;
              }
        }

    
    }

    const MAX_JPEG_FILE_SIZE = 157286400
    const MAX_GIF_FILE_SIZE = 20971520
    const MAX_PNG_FILE_SIZE = 20971520

    if (
        // @ts-ignore
        (files?.[0]?.type === 'image/jpeg' || files?.[0]?.type === 'image/jpg') && files?.[0]?.size > MAX_JPEG_FILE_SIZE
    ) {
        toasts.error('Максимальный размер jpeg-файла - 150Мб')
        failedChecks.size = true
    }

    if (
        // @ts-ignore
        (files?.[0]?.type === 'image/png') && files?.[0]?.size > MAX_PNG_FILE_SIZE
    ) {
        toasts.error('Максимальный размер png-файла - 20Мб')
        failedChecks.size = true
    }

    if (
        // @ts-ignore
        files?.[0]?.type === 'image/gif' && files?.[0]?.size > MAX_GIF_FILE_SIZE
    ) {
        toasts.error('Максимальный размер gif-файла - 20Мб')
        failedChecks.size = true
    }

    if (!['image/jpeg', 'image/jpg', 'image/gif', 'image/png', ...(isModer ? ['image/png'] : [])].includes(files?.[0]?.type)) {
        toasts.error('Допустимые форматы: jpg, png, gif')
        failedChecks.size = true
    }

    const {
        size: failedSize,
        dimensions: failedDimensions,
        ratio: failedRatio
    } = failedChecks

    if (failedSize || failedDimensions || failedRatio) {
        return false
    }

    return true
}import {Profile, TFile} from "@brg/api";
import {bProfile} from "@brg/auth";

export const uploadValidator = async (files: TFile[], toasts: any, isWideImageType: boolean, profile?: Profile<'Local'>, additionalValidate?: boolean) => {

    if (files?.length === 0 || !profile) return true;

    const isModer = bProfile.isModer(profile)
    const failedChecks: any = {}
    const loadFile = () =>
        new Promise((resolve, reject) => {
            const fr = new FileReader()
            fr.onload = function () {
                // file is loaded
                const img = new Image()

                img.onload = function () {
                    const { width, height } = img
                    resolve({
                        width,
                        height
                    })
                }

                // @ts-ignore
                img.src = fr.result // is the data URL because called with readAsDataURL
            }
            // @ts-ignore
            fr.readAsDataURL(files[0])
        })

    // @ts-ignore
    const { height, width } = await loadFile()

    if (
        (height >= width && (height > 5262 || width > 3720)) ||
        (width > height && (height > 3720 || width > 5262))
    ) {
        toasts.error('Максимальные размеры изображения - 3720х5262 и 5262x3720')
        failedChecks.dimensions = true
    }


    const ratio = width / height;


    if (isWideImageType) {
        // const isSmallWideImage = ratio > 1.47 && ratio < 1.49
        // const isLargeWideImage = ratio > 1.79 && ratio < 1.81
        // if (!isSmallWideImage && !isLargeWideImage) {
        //   toasts.error(
        //     'Изображение неправильное (отношение ширины к высоте должно быть или 1.48, или 1.8)'
        //   )
        //   failedChecks.ratio = true
        // }
    } else {
        if (ratio < 0.6) {
            toasts.error(
                'Изображение слишком длинное (отношение ширины к высоте должно быть 0.6 и более)'
            )
            failedChecks.ratio = true
        }
        if (additionalValidate) {
            if (ratio < 0.6 || ratio > 0.8) {
                toasts.error("Изображение должно быть вертикальным (отношение ширины к высоте от 0.6 до 0.8)");
                failedChecks.ratio = true;
              }
        }

    
    }

    const MAX_JPEG_FILE_SIZE = 157286400
    const MAX_GIF_FILE_SIZE = 20971520
    const MAX_PNG_FILE_SIZE = 20971520

    if (
        // @ts-ignore
        (files?.[0]?.type === 'image/jpeg' || files?.[0]?.type === 'image/jpg') && files?.[0]?.size > MAX_JPEG_FILE_SIZE
    ) {
        toasts.error('Максимальный размер jpeg-файла - 150Мб')
        failedChecks.size = true
    }

    if (
        // @ts-ignore
        (files?.[0]?.type === 'image/png') && files?.[0]?.size > MAX_PNG_FILE_SIZE
    ) {
        toasts.error('Максимальный размер png-файла - 20Мб')
        failedChecks.size = true
    }

    if (
        // @ts-ignore
        files?.[0]?.type === 'image/gif' && files?.[0]?.size > MAX_GIF_FILE_SIZE
    ) {
        toasts.error('Максимальный размер gif-файла - 20Мб')
        failedChecks.size = true
    }

    if (!['image/jpeg', 'image/jpg', 'image/gif', 'image/png', ...(isModer ? ['image/png'] : [])].includes(files?.[0]?.type)) {
        toasts.error('Допустимые форматы: jpg, png, gif')
        failedChecks.size = true
    }

    const {
        size: failedSize,
        dimensions: failedDimensions,
        ratio: failedRatio
    } = failedChecks

    if (failedSize || failedDimensions || failedRatio) {
        return false
    }

    return true
}